import axios from "./index";

class ClientApi {
    static Get = () => {
        return axios.get(`${base}`);
    };
}
let base = "dashboard/client";

export default ClientApi;
